/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CustomAssistantsService
 */

/**
 *  Custom Assistant - the new v2 model for portal-specific assistants
 */

/**
 *  Summary view of a Custom Assistant for list responses
 *  Contains essential information without heavy details like full resource configurations
 */

/**
 *  Summary view of a Custom Assistant Template for list responses
 *  Contains essential information without heavy details like full resource configurations
 */

/**
 *  CHIRP-safe version of CustomAssistantPermissionWithUserTeamPermissions that excludes portalId.
 *  The portalId is accessed from ChirpContext instead.
 */

/**
 *  Collection of resource configurations for a Custom Assistant
 */

/**
 *  Configuration for a specific resource type
 */

/**
 *  Request to create a new custom assistant
 */

/**
 *  Response for creating a new custom assistant
 */

/**
 *  Request to create a new custom assistant
 */

/**
 *  Response for creating a new custom assistant template
 */

/**
 *  Cursor for custom assistants pagination
 */

/**
 *  Request to delete a custom assistant
 */

/**
 *  Response for deleting a custom assistant
 */

/**
 *  Request to delete a custom assistant template
 */

/**
 *  Response for deleting a custom assistant template
 */

/**
 *  Request to duplicate an existing custom assistant
 */

/**
 *  Response for duplicating a custom assistant
 */

/**
 *  Request to get a custom assistant by ID
 */

/**
 *  Response for getting a custom assistant by ID
 */

/**
 *  Request to install a custom assistant template using its global ID
 */

/**
 *  Response for installing a custom assistant template using its global ID
 */

/**
 *  Request to install a custom assistant template on a portal
 *  @deprecated This RPC is deprecated. Use installCustomAssistantTemplateFromGlobalId instead.
 */

/**
 *  Response for installing a custom assistant template on a portal
 *  @deprecated This RPC is deprecated. Use installCustomAssistantTemplateFromGlobalId instead.
 */

/**
 *  Request to install a custom assistant template
 *  @deprecated This RPC is deprecated. Use installCustomAssistantTemplateFromGlobalId instead.
 */

/**
 *  Response for installing a custom assistant template
 *   @deprecated This RPC is deprecated. Use installCustomAssistantTemplateFromGlobalId instead.
 */

/**
 *  Request to install a custom assistant template
 */

/**
 *  Response for installing a custom assistant template
 */

/**
 *  Request to list all installed custom assistant instances of a specific template.
 */

/**
 *  Response for listing all portal installations of a specific custom assistant template with pagination
 */

/**
 *  Request to list available custom assistant templates for installation
 */

/**
 *  Response for listing available custom assistant templates with pagination
 */

/**
 *  Request to list custom assistants with pagination support
 */

/**
 *  Response for listing custom assistants with pagination
 */

/**
 *  Request to lookup a user's installed assistant by global template ID
 */

/**
 *  Response for looking up a user's installed assistant by global template ID
 */

/**
 *  Request to uninstall a custom assistant template from a portal
 *  @deprecated This RPC is deprecated.
 */

/**
 *  Response for uninstalling a custom assistant template from a portal
 *  @deprecated This RPC is deprecated.
 */

/**
 *  Request to uninstall a custom assistant template
 *  @deprecated This RPC is deprecated. Use deleteCustomAssistant instead.
 */

/**
 *  Response for uninstalling a custom assistant template
 *  @deprecated This RPC is deprecated. Use deleteCustomAssistant instead.
 */

/**
 *  Request to update an existing custom assistant
 */

/**
 *  Response for updating a custom assistant
 */

/**
 *  Request to update a custom assistant template
 */

/**
 *  Response for updating a custom assistant template
 */

/**
 *  CHIRP-safe version of CustomAssistantPermissionWithUserTeamPermissions for creation requests.
 *  This interface is used during custom assistant creation when the CustomAssistantId doesn't exist yet.
 *  The portalId is accessed from ChirpContext, and the CustomAssistantId will be set after creation.
 */

/**
 *  Represents a custom assistant template installation on a portal.
 *  Contains information about which portal has the template installed and when.
 */

export const getCustomAssistantRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CustomAssistantsService',
  rpcName: 'getCustomAssistant',
  auth: 'app',
  fingerprint: 'yCO9d0RfDCWilHBkubAEt3y57X1OhCp4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listCustomAssistantsRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CustomAssistantsService',
  rpcName: 'listCustomAssistants',
  auth: 'app',
  fingerprint: 'JYtMjnLlu6ye4S-ilSz9Gny57X1OhCp4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createCustomAssistantRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CustomAssistantsService',
  rpcName: 'createCustomAssistant',
  auth: 'app',
  fingerprint: 'b30wPIhbrNMtJuxGapV9Dny57X1OhCp4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const duplicateCustomAssistantRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CustomAssistantsService',
  rpcName: 'duplicateCustomAssistant',
  auth: 'app',
  fingerprint: 'TV1OmoVjVSMnKTIB03Qhxny57X1OhCp4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateCustomAssistantRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CustomAssistantsService',
  rpcName: 'updateCustomAssistant',
  auth: 'app',
  fingerprint: '-b35E_qKjMRLAGMNPsi31Xy57X1OhCp4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteCustomAssistantRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CustomAssistantsService',
  rpcName: 'deleteCustomAssistant',
  auth: 'app',
  fingerprint: 'RiKil3xwvtd2nY68K55TMHy57X1OhCp4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const installCustomAssistantTemplateFromGlobalIdRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CustomAssistantsService',
  rpcName: 'installCustomAssistantTemplateFromGlobalId',
  auth: 'app',
  fingerprint: 'D1n8DHTyeUbp3vIx8Se84ny57X1OhCp4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const lookupUserInstalledAssistantByGlobalIdRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CustomAssistantsService',
  rpcName: 'lookupUserInstalledAssistantByGlobalId',
  auth: 'app',
  fingerprint: '5vJamomPmsTMqb1gC0iXn3y57X1OhCp4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listCustomAssistantTemplatesRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CustomAssistantsService',
  rpcName: 'listCustomAssistantTemplates',
  auth: 'app',
  fingerprint: 'up5iHTpadPZ4tvsKY83SXny57X1OhCp4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const installCustomAssistantTemplateRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CustomAssistantsService',
  rpcName: 'installCustomAssistantTemplate',
  auth: 'app',
  fingerprint: 'bnniMhAzCE9BnUBSIRxRdXy57X1OhCp4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const uninstallCustomAssistantTemplateRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CustomAssistantsService',
  rpcName: 'uninstallCustomAssistantTemplate',
  auth: 'app',
  fingerprint: '9d0hnQtDQRcaNcRfkJub-3y57X1OhCp4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const installCustomAssistantTemplateOnPortalRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CustomAssistantsService',
  rpcName: 'installCustomAssistantTemplateOnPortal',
  auth: 'app',
  fingerprint: '28sUuBzd0dBLzk_HyCG5sny57X1OhCp4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const uninstallCustomAssistantTemplateFromPortalRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CustomAssistantsService',
  rpcName: 'uninstallCustomAssistantTemplateFromPortal',
  auth: 'app',
  fingerprint: 'juZUFa5ZrwfE49nxW9ud9Xy57X1OhCp4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const isCustomAssistantTemplateInstalledRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CustomAssistantsService',
  rpcName: 'isCustomAssistantTemplateInstalled',
  auth: 'app',
  fingerprint: 'NAAdfU3qIFFNCQxC602Vu5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listCustomAssistantsTemplateInstallsRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CustomAssistantsService',
  rpcName: 'listCustomAssistantsTemplateInstalls',
  auth: 'app',
  fingerprint: 'sX2m0hv0R6c8irLHIBgTuHy57X1OhCp4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createCustomAssistantTemplateRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CustomAssistantsService',
  rpcName: 'createCustomAssistantTemplate',
  auth: 'app',
  fingerprint: '6GowtdA74WszYrEmP9-gjXy57X1OhCp4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateCustomAssistantTemplateRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CustomAssistantsService',
  rpcName: 'updateCustomAssistantTemplate',
  auth: 'app',
  fingerprint: '02E6i5qNINOLXjhro-TSpXy57X1OhCp4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteCustomAssistantTemplateRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CustomAssistantsService',
  rpcName: 'deleteCustomAssistantTemplate',
  auth: 'app',
  fingerprint: 'boP6ILV7a2U7yDlzRXInHXy57X1OhCp4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};